import React from 'react';

import DriveSummarySingle from './DriveSummaySingle';
import DriveSummaryDual from './DriveSummaryDual';
import DriveSummaryTriple from './DriveSummaryTriple';

const DriveSummary = ({ body }) => {
    const { drives } = body;

    if (!drives) {
        return <>Drive 내용이 없습니다.</>
    }

    return (
        <>
            {(drives.length === 1) && <DriveSummarySingle drives={drives}/>}
            {(drives.length === 2) && <DriveSummaryDual drives={drives} />}
            {(drives.length === 3) && <DriveSummaryTriple drives={drives} />}
        </>
    );
};

export default DriveSummary;
